

import { useQuery } from "react-query";
import { getTeacherEvaluationCriterias } from "../services/school/teacher/teacherEvaluationCriteria";
import { PagedRequestType } from "../types/PagedResults";
import { Key_teacherEvaluationCriterias } from "../utils/constants";

export const useGetTeacherEvaluationCriteriasQuery = (data: PagedRequestType, options:any= null) =>
  useQuery(
    [Key_teacherEvaluationCriterias, JSON.stringify(data)],
    () => getTeacherEvaluationCriterias(data),
    options?{...options}:{}
  );